<template>
  <div id="detail" class="detail">

    <!-- 头部区域 -->
    <div class="header-section">
      <div class="header-bg">
        <img src="@/assets/rightsDetails/Daoan/headbackground.png" alt="头部背景" class="header-bg-img">
        <div class="advantages-section">
      <!-- 优势一 -->
      <div class="advantage-item advantage-item-1">
        <div class="advantage-header">
          <div class="advantage-title">优势一: 日常检测, 时刻关注</div>
          <div class="advantage-content">
            <div class="advantage-text advantage-text-1">
              为用户提供智能监测手表及使用手册，用户需正确佩戴手表。提供24小时实时监测多项健康指标，包括心率、血氧饱和度、体温、睡眠质量、血压、每日步数等，所有采集数据实时上传至"大救星健康版App"，通过AI算法模型计算身体健康评分，用户可随时查看自身健康状态。
            </div>
          </div>
        </div>
      </div>

      <!-- 优势二 -->
      <div class="advantage-item advantage-item-2">
        <div class="advantage-header">
          <div class="advantage-title">优势二: 精准守护, 智能相伴</div>
          <div class="advantage-content">
            <div class="advantage-text advantage-text-2">
              基于中国中医科学院研究（中医五藏状态监测技术及科学中医报告），根据用户周期性身体指标趋势，为用户提供调理或检查建议。提供24小时在线医疗咨询服务，提供实用便捷工具，如"小星"互动健康问答机器人、"健康查一查"学习疾病知识、AI在线互动健康咨询、AI体检筛查帮助分析报告等。
            </div>
          </div>
        </div>
      </div>

      <!-- 优势三 -->
      <div class="advantage-item advantage-item-3">
        <div class="advantage-header">
          <div class="advantage-title">优势三: 协助就医, 传递温暖</div>
          <div class="advantage-content">
            <div class="advantage-text advantage-text-3">
              用户驾驶途中如遇突发疾病或意外伤害，大救星可提供医院转送转运、出院返程、住院医疗监护信息传递等服务。提供门诊协助，包括指定医院绿色通道挂号服务、紧急医疗转运、安排医疗返程转运、住院医疗监护等服务。
            </div>
          </div>
        </div>
      </div>

      <!-- 优势四 -->
      <div class="advantage-item advantage-item-4">
        <div class="advantage-header">
          <div class="advantage-title">优势四: 安全管家, 守护全家</div>
          <div class="advantage-content">
            <div class="advantage-text advantage-text-4">
              大救星为用户提供免费咨询推荐服务，包括"星使"服务、紧急医疗咨询、紧急信息传递、协助呼叫救护车、医疗机构推荐、养老、行李或证件丢失协助、紧急现金协调、安保服务、法律援助、紧急疏散、国内外体检、二次诊疗意见、处方协助、机场/车站接送服务等。
            </div>
          </div>
        </div>
      </div>
        <!-- 服务权益说明部分 -->
    <div class="service-rights-section">
      <div class="service-rights-header">
        <img src="@/assets/rightsDetails/Daoan/BackgroundofServiceRightsExplanation.png" alt="服务权益说明背景" class="service-rights-bg">
        <div class="service-rights-title">
          <span class="star-icon">★</span>
          <span>服务权益说明</span>
          <span class="star-icon">★</span>
        </div>
      </div>

      <div class="service-list">
        <!-- 24小时健康监测服务 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('health-monitoring') }">
          <div class="service-item-header" @click="toggleItem('health-monitoring')">
            <div class="service-item-title">24小时健康监测服务</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('health-monitoring') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('health-monitoring')">
            <div class="service-item-text">
              为用户提供智能监测手表及使用说明书，用户正确佩戴手表。可提供24小时实时掌握包括心率、血氧饱和度、血压、体温、睡眠质量及日常运动步数等在内的多项健康指标。所有数据实时上传到大救星健康版App中，依托大救星AI算法模型计算身体健康分数，供用户随时掌握自身健康情况。
            </div>
          </div>
        </div>

        <!-- 24小时疾病趋势预报服务 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('disease-trend') }">
          <div class="service-item-header" @click="toggleItem('disease-trend')">
            <div class="service-item-title">24小时疾病趋势预报服务</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('disease-trend') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('disease-trend')">
            <div class="service-item-text">
              依托中国中医科学院科研成果--中医五藏态势监测技术及科学中医诊断，用户佩戴满24小时后显示“您有一份新的中医报告”，点击“查看报告”显示：心藏、肝藏、肾藏、脾藏评分结果并能查看其它体测数据。根据周期性身体指标趋势向用户提供调理或检查建议。
            </div>
          </div>
        </div>

        <!-- 24小时及时疾病预警服务 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('disease-warning') }">
          <div class="service-item-header" @click="toggleItem('disease-warning')">
            <div class="service-item-title">24小时及时疾病预警服务</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('disease-warning') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('disease-warning')">
            <div class="service-item-text">
              用户通过佩戴这款智能监测手表日常监测，实时掌握自己的生命体征。一旦突发健康数据异常，手表会及时发出提醒，提醒用户关注异常信息并采取必要的处置措施。
            </div>
          </div>
        </div>

        <!-- 24小时在线医疗咨询服务 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('online-consultation') }">
          <div class="service-item-header" @click="toggleItem('online-consultation')">
            <div class="service-item-title">24小时在线医疗咨询服务</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('online-consultation') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('online-consultation')">
            <div class="service-item-text">
              为用户提供24小时在线医疗咨询服务，由三甲医院主治及以上全科及专科医生通过电话、视频或图文方式为用户提供一对一的心血管疾病专科咨询、日常医学咨询、诊前就医指导、慢性病管理咨询、预防及日常保健咨询等，由专业分诊人员根据问诊需求匹配医生、不可指定医生。在线咨询完毕后，根据实际需求享受线上购药及递送药品等全流程服务。药品及递送费用都由用户承担。
            </div>
          </div>
        </div>

        <!-- 门诊协助 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('outpatient') }">
          <div class="service-item-header" @click="toggleItem('outpatient')">
            <div class="service-item-title">门诊协助</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('outpatient') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('outpatient')">
            <div class="service-item-text">
              用户可根据自身临床病症、就诊时间、地点等情况，在大救星健康版App端提交挂号协助需求（需核实在平台网络医院名录内），为用户提供指定医院的挂号绿通服务。用户需在线填写姓名、身份证号、联系电话、期望就诊医院、期望科室、病情描述和诊断、诊断报告和其他医学材料等，提交成功后48小时内客服人员会与用户联系核实信息，挂号服务费、挂号费应根据实际发生的金额提前与客户确认。如挂号成功后，产生的挂号服务费用、挂号费需由用户承担。
            </div>
          </div>
        </div>

        <!-- 紧急医疗转运 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('emergency-transfer') }">
          <div class="service-item-header" @click="toggleItem('emergency-transfer')">
            <div class="service-item-title">紧急医疗转运</div>
            <div class="service-item-availability">不限次, 限额50万</div>
            <img 
              :src="expandedItems.includes('emergency-transfer') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('emergency-transfer')">
            <div class="service-item-text">
              用户在驾驶车辆工作期间如遇突发疾病或意外事故，被紧急送往就近医疗机构救治后，若经大救星医生及主治医生共同确定，用户所在医院医疗设施无法满足病情需要，需要转运到上级医院进一步救治。在当地医院开具转院证明的情形下，大救星通过适当的转运方式将用户运送至最近的且能够提供必要医疗设施的医疗场所。大救星承担的费用总额以权益卡上载明的相应的服务限额为限。
            </div>
          </div>
        </div>

        <!-- 医疗送返 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('medical-return') }">
          <div class="service-item-header" @click="toggleItem('medical-return')">
            <div class="service-item-title">医疗送返</div>
            <div class="service-item-availability">不限次, 限额50万</div>
            <img 
              :src="expandedItems.includes('medical-return') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('medical-return')">
            <div class="service-item-text">
              用户在驾驶车辆工作期间遭遇突发疾病或意外事故，在当地医院住院治疗一段时间后病情稳定或达到出院标准，经大救星的医生及主治医生共同确认因医疗必要性需送返回到常住地的医疗机构或家中进一步治疗或休养的情形下，大救星安排适当的转运方式将客户送返到指定地点。大救星承担的费用总额以权益卡上载明的相应的服务额度为限。
            </div>
          </div>
        </div>

        <!-- 住院医疗监护 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('inpatient-monitoring') }">
          <div class="service-item-header" @click="toggleItem('inpatient-monitoring')">
            <div class="service-item-title">住院医疗监护</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('inpatient-monitoring') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('inpatient-monitoring')">
            <div class="service-item-text">
              用户在驾驶车辆工作期间突发疾病或意外事故后住院治疗期间，受用户或用户亲属委托，大救星医务人员会与用户的主治医生或医院保持信息协同，监护用户入院后的医疗状况，向其家庭成员传递合法的、必要医疗情况信息。
            </div>
          </div>
        </div>

        <!-- 健康查一查 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('health-check') }">
          <div class="service-item-header" @click="toggleItem('health-check')">
            <div class="service-item-title">健康查一查</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('health-check') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('health-check')">
            <div class="service-item-text">
              用户可以通过大救星健康版App“健康查一查”功能，了解常见疾病知识，包含病因、症状、就医、诊断和治疗等疾病相关知识内容。
            </div>
          </div>
        </div>

        <!-- AI健康咨询 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('ai-consultation') }">
          <div class="service-item-header" @click="toggleItem('ai-consultation')">
            <div class="service-item-title">AI健康咨询</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('ai-consultation') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('ai-consultation')">
            <div class="service-item-text">
              用户可以通过大救星健康版App“健康咨询”功能，在线询问AI医生疾病治疗建议。如果AI医生无法满足问诊需求，可以直接点击“转人工”，平台将提供专业医师在线图文、电话及视频等24小时在线医疗咨询服务。
            </div>
          </div>
        </div>

        <!-- AI体检报告解读 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('ai-report') }">
          <div class="service-item-header" @click="toggleItem('ai-report')">
            <div class="service-item-title">AI体检报告解读</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('ai-report') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('ai-report')">
            <div class="service-item-text">
              用户可以大救星健康版App上传自己的体检报告照片，上传成功后点击“立即分析”，系统会自动识别体检报告内容、安排人工智能分析，并由专业医师进行二次检查确认后得出健康评级结论和异常汇总提供给用户。
            </div>
          </div>
        </div>

        <!-- 安全管家服务 -->
        <div class="service-item" :class="{ 'expanded': expandedItems.includes('safety-butler') }">
          <div class="service-item-header" @click="toggleItem('safety-butler')">
            <div class="service-item-title">安全管家服务</div>
            <div class="service-item-availability">不限次</div>
            <img 
              :src="expandedItems.includes('safety-butler') 
                ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
              alt="箭头" 
              class="arrow-icon"
            >
          </div>
          <div class="service-item-content" v-show="expandedItems.includes('safety-butler')">
            <div class="service-item-text">
              大救星可为用户提供包含星使服务、紧急医疗咨询、紧急信息传递、协助呼叫救护车、医疗机构推荐、照顾老年人、遗失行李或文件援助、应急现金协调、安保服务、法律援助、紧急撤离、境内外体检、二次诊疗、处方援助、接送机等服务的免费咨询和推介，由此产生的第三方费用需由用户承担。
            </div>
          </div>
        </div>
       
    </div>

 
    </div>
      <!-- 底部背景 -->
      <div class="bottom-section">
        <img src="@/assets/rightsDetails/Daoan/BottomBackground.png" alt="底部背景" class="bottom-bg">
      </div>
      </div>
      </div>
       <!-- 优势部分 -->
   
    </div>

   
   
 </div>
</template>

<script>

/**
 * 权益详情页面组件
 * 展示大救星服务的健康权益说明
 */
export default {

  name: 'Equity',
  data() {
    return {

      /**
       * 展开的服务项列表
       * @type {Array<string>}
       */
      expandedItems: ['health-monitoring'] // 默认展开第一项
    };
  },
  mounted() {

    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px';
    }
  },
  created() {
    document.title = '权益详情';
    console.log(localStorage.getItem('equityinfo'));
    this.equityinfoType = localStorage.getItem('equityinfo');
  },
  beforeCreate() {
    document

      .querySelector('#app')
      .setAttribute('style', 'background-color:#F2F3F5');
  },
  methods: {  

    /**
     * 切换服务项的展开/折叠状态
     * @param {string} itemId - 服务项ID
     */
    toggleItem(itemId) {
      const index = this.expandedItems.indexOf(itemId);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(itemId);
      }
    }
  }
};
</script>


<style scoped>
.detail {
  width: 100%;
  height: auto;
  background-color: #E0F6FD;
  overflow-x: hidden;
}

/* 头部区域 */
.header-section {
  width: 100%;
  position: relative;
}

.advantages-placeholder {
  width: 100%;
  /* height: 1650px; */
  visibility: hidden;
  margin-top: 23%;
}

.header-bg {
  width: 100%;
  position: relative;
}

.header-bg-img {
   width: 100%; 
  display: block;
  position: relative;
  z-index: 1;
}

.header-content {
   position: absolute;
  top: 0;
   left: 0;
   width: 100%; 

  padding: 32px 16px;
  box-sizing: border-box;
}

.brand-name {
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.star-icon {
  margin: 0 3px;
  font-size: 14px;
}

.main-title {
  color: #1E88E5;
  font-size: 19px;
   font-weight: bold;
  text-align: center;
  line-height: 1.2;
}

/* 优势部分 */
.advantages-section {
  width: 100%;
  padding: 13px 10px 0px 13px;
  margin-top: -220px;
  position: relative;
  z-index: 2;
  /* position: absolute;

  top: 23%; */
  /* background-color: #E0F6FD; */
}

.advantage-item {
   width: 100%; 
  margin-bottom: 13px;
  /* background-color: #fff;
  border-radius: 6px; */
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}

.advantage-item-1 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage1Background.png');
}

.advantage-item-2 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage2Background.png');
}

.advantage-item-3 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage3Background.png');
}

.advantage-item-4 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage4Background.png');
}

.advantage-header {
   width: 100%;

  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

.advantage-title {
  position: relative;
  color: #fff;
  font-size: 18px;
   font-weight: bold;

  text-align: left;
  padding: 16px 13px 8px;
  z-index: 1;
}

.advantage-content {
  /* background-color: #fff; */
  padding: 0 13px 16px;
  margin: 0;
  border-radius: 0 0 6px 6px;
  position: relative;
  z-index: 1;
}

.advantage-text {
  color: #333;
  font-size: 16px;
  line-height: 1.6;
  text-align: justify;
}

.advantage-text-1 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage1Backgroundtit.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 15px;
}

.advantage-text-2 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage2Backgroundtit.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 15px;
}

.advantage-text-3 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage3Backgroundtit.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 15px;
}

.advantage-text-4 {
  background-image: url('~@/assets/rightsDetails/Daoan/Advantage4Backgroundtit.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 15px;
}

/* 服务权益说明部分 */
.service-rights-section {
    width: 100%;
  padding: 16px 0;
}

.service-rights-header {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
  padding: 0 10%;
  }

.service-rights-bg {
  width: 100%;
  display: block;
}

.service-rights-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.service-list {
    width: 100%;

  padding: 0 8px;
  position: relative;
  z-index: 1;
}

.service-item {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.service-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px;
    cursor: pointer;

  background-color: #fff;
  transition: background-color 0.3s;
}

.service-item-header:active {
  background-color: #f5f5f5;
}

.service-item-title {
  flex: 1;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  margin-right: 6px;
  color: #0943FD;
}

.service-item-availability {
  color: #333333;
  font-size: 15px;
  margin-right: 6px;
  white-space: nowrap;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s;
}

.service-item.expanded .arrow-icon {
  transform: rotate(180deg);
}

.service-item-content {
  padding: 0 13px 13px;
  background-color: #fff;
}

.service-item-text {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
  background-color: #EDF6FF;
  border-radius: 5px;
  padding: 10px;
}

/* 底部区域 */
.bottom-section {
  width: calc(100% + 26px);
  margin-left: -13px;
  margin-right: -13px;
  margin-top: -300px;
  position: relative;
  z-index: 0;
}

.bottom-bg {
    width: 100%;

  display: block;
}


</style>


// WEBPACK FOOTER //
// src/views/detailsH5/equity.vue